module.exports = __webpack_public_path__ + "static/media/ikebukuro-hanakawado-2.3ad9335e.jpg";